import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#181818",
      d: "M10.237 10.477a5 5 0 0 1 5 5V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-3.523a5 5 0 0 1 5-5zM7.618 0a4.762 4.762 0 1 1 0 9.524 4.762 4.762 0 0 1 0-9.524"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "customer"}) } }